module.exports = __webpack_public_path__ + "img/f4-04.23cc5c63.png";